import { IEBlockMaterial } from '../../models/eBlockMaterial.model';
import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { AppAction } from '../app';
import {
  CLEAR_EBLOCK_MATERIAL,
  CREATE_EBLOCK_MATERIAL,
  FETCH_EBLOCK_MATERIAL,
  FETCH_EBLOCK_MATERIAL_LIST,
  UPDATE_EBLOCK_MATERIAL,
} from './eBlockMaterial.action';
import { EBlockMaterialState } from './eBlockMaterial.type';

const initialState: EBlockMaterialState = {
  errorMessage: '',
  item: {} as Readonly<IEBlockMaterial>,
  items: [] as ReadonlyArray<IEBlockMaterial>,
  loading: false,
  totalItems: 0,
};

export default (
  state: EBlockMaterialState = initialState,
  action: AppAction,
): EBlockMaterialState => {
  switch (action.type) {
    case REQUEST(FETCH_EBLOCK_MATERIAL_LIST):
    case REQUEST(CREATE_EBLOCK_MATERIAL):
    case REQUEST(FETCH_EBLOCK_MATERIAL):
    case REQUEST(UPDATE_EBLOCK_MATERIAL):
      return { ...state, loading: true };
    case SUCCESS(FETCH_EBLOCK_MATERIAL_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_EBLOCK_MATERIAL_LIST):
    case FAILURE(CREATE_EBLOCK_MATERIAL):
    case FAILURE(FETCH_EBLOCK_MATERIAL):
    case FAILURE(UPDATE_EBLOCK_MATERIAL):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case SUCCESS(CREATE_EBLOCK_MATERIAL):
    case SUCCESS(FETCH_EBLOCK_MATERIAL):
    case SUCCESS(UPDATE_EBLOCK_MATERIAL):
      return { ...state, loading: false, item: action.payload.data };
    case CLEAR_EBLOCK_MATERIAL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
